var map = {
	"./landingpage/landingpage.module": [
		"./src/app/landingpage/landingpage.module.ts",
		"landingpage-landingpage-module"
	],
	"./qr-generator/qr-generator.module": [
		"./src/app/qr-generator/qr-generator.module.ts",
		"qr-generator-qr-generator-module"
	],
	"./survey/survey.module": [
		"./src/app/survey/survey.module.ts",
		"survey-survey-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;